import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Draggable from '@components/Draggable';
import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import InfoIcon from '@icons/InfoIcon';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import MyMenuFooter from './components/MyMenuFooter';
import MyMenuHeader from './components/MyMenuHeader';
import MyMenuItem from './components/MyMenuItem';

declare module '@stackflow/config' {
    interface Register {
        MyMenuActivity: {};
    }
}

const MyMenuActivity: ActivityComponentType<'MyMenuActivity'> = () => (
    <AppScreen>
        <CtaLayout header={<MyMenuHeader/>}
            footer={<MyMenuFooter />} >
            <Container fullWidth >
                <Tooltip top={18} right={16}
                    align='right'
                    visibleKey='myMenuSort' >
                        아이콘을 손으로 두번 터치하면<br/>
                        카드 순서를 변경할 수 있어요.
                </Tooltip>
                <CommentRow>
                    <InfoIcon color={colors.gray6}/>
                    <Text color={colors.gray9}
                        size='body-long' >
                            상단부터 순서대로 5개의 MY메뉴가 메인페이지에 노출됩니다.
                    </Text>
                </CommentRow>
                <Contents spacing={4}>
                    {Array.from({ length: 10 }).map((_, i) => (
                        <MyMenuItem key={`myMenu ${i}`}
                            id={i.toString()} />
                    ))}
                </Contents>
            </Container>
        </CtaLayout>
    </AppScreen>
);

const Container = styled(Column)`
    background-color: var(--color-gray2);
    position: relative;
    max-width: 100vw;
    overflow: hidden;
`;

const Contents = styled(Draggable)`
    padding: 0 20px 64px;
    max-width: 100%;
    overflow-x: hidden;
`;

const CommentRow = styled(Row)`
    padding: 18px 20px 24px;
`;

export default MyMenuActivity;
